import(/* webpackMode: "eager" */ "/builds/dustintech/dev/dustintech/web/libraries/dustin-microsite/apps/productsite-beta/src/app/global-error.tsx");
